export default "__VITE_ASSET__Dt_5$zhm__"